module.exports = __webpack_public_path__ + "static/media/sesi-logo.489f43d9.svg";